import { L10N } from 'global/localization'
import type { TrxHistoryListItemProps } from 'global/types/props'
import type { TrxHistoryListItemResponse } from 'global/types/responses'
import { formatCurrency, formatDate, formatDateTime } from 'shared/services/utils'
import { StatusBadge } from 'shared/components/status-badge'
import Icon from 'shared/components/icon'

export const TrxHistoryListItem = ({ trxDetail, onClick, onReferralRewardClick }: TrxHistoryListItemProps) => (
  <button
    className='flex flex-col bg-white p-3 mb-4 last:mb-0 w-full text-left'
    type='button'
    onClick={() => trxDetail.isReferralReward && onReferralRewardClick ? onReferralRewardClick(trxDetail.id) : onClick(trxDetail.id)}
  >
    <div className='flex flex-row gap-2 items-center mb-3 w-full'>
      {trxDetail.isReferralReward ? <GiftIcon /> : <Icon icon='car' size={20} />}
      <div className='flex flex-col flex-1'>
        <div className='font-medium text-sm'>{trxDetail.name}</div>
        <div className='text-neutral text-xs'>
          {trxDetail.status.toLowerCase() === 'paid' && trxDetail.paidDate
            ? formatDateTime(trxDetail.paidDate, true)
            : trxDetail.transactionDate
              ? formatDateTime(trxDetail.transactionDate, true)
              : '-'}
        </div>
      </div>
      <StatusBadge
        label={trxDetail.isReferralReward ? 'Active' : trxDetail.statusLabel}
        value={trxDetail.status}
      />
    </div>

    <div className='font-medium w-full'>{trxDetail.carModelName}</div>

    <div className='flex flex-row items-center justify-between w-full mb-3 last:mb-0'>
      <div className='text-neutral text-xs'>{trxDetail.invoiceNo}</div>
      {!trxDetail.isReferralReward && (
        <div className='text-sm text-right min-w-24'>{formatCurrency(trxDetail.price ?? 0)}</div>
      )}
    </div>

    {getAdditionalInfo(trxDetail)}
  </button>
)

const GiftIcon = () => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={1.8}
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <polyline points='20 12 20 22 4 22 4 12' />
    <rect x='2' y='7' width='20' height='5' />
    <line x1='12' y1='22' x2='12' y2='7' />
    <path d='M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z' />
    <path d='M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z' />
  </svg>
)

const getAdditionalInfo = (trxDetail: TrxHistoryListItemResponse) => {
  switch (trxDetail.status.toLowerCase()) {
    case 'pending':
      return trxDetail.expiredDate ? (
        <div className='flex flex-row items-center justify-between w-full bg-background border border-border px-2 py-1'>
          <div className='text-sm'>{L10N.LABEL.EXPIRED_IN}</div>
          <div className='text-sm text-right'>{formatDateTime(trxDetail.expiredDate, true)}</div>
        </div>
      ) : (
        <></>
      )

    case 'paid':
      return trxDetail.isAutoRenewal ? (
        <div className='flex flex-row items-center justify-between w-full bg-secondary-background border border-secondary-border px-2 py-1'>
          <div className='text-sm'>{L10N.LABEL.AUTO_RENEWAL}</div>
          <div className='text-sm text-right'>
            {trxDetail.serviceEndDate ? formatDate(trxDetail.nextPaymentDate) : '-'}
          </div>
        </div>
      ) : (
        <></>
      )

    default:
      return <></>
  }
}
